(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratAddPaymentCorrectionController', ContratAddPaymentCorrectionController);

    ContratAddPaymentCorrectionController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CollectionListe'];

    function ContratAddPaymentCorrectionController ($scope, $stateParams, $uibModalInstance, entity, CollectionListe) {
        var vm = this;
        vm.payment = entity;
        vm.paymentCorrection = {};

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };
        
        vm.save = function () {
            vm.isSaving = true;
            vm.paymentCorrection.paymentCorrectionId =    vm.payment.paymentReceipt.id;
          //  vm.paymentCorrection.newAmount = vm.payment.paidInclTax - vm.paymentCorrection.tmpNewAmount 
            CollectionListe.paymentCorrection(vm.paymentCorrection, onSaveSuccess, onSaveError);
          
        };
       
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

//        vm.datePickerOpenStatus = {};
//        vm.datePickerOpenStatus.dateSuppression = false;
//
//        vm.openCalendar = function(date) {
//            vm.datePickerOpenStatus[date] = true;
//        };
    }
})();
